exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay--active:before{opacity:1!important;background:rgba(0,0,0,.5)!important}.dialog{box-shadow:0 3px 5px -1px hsla(0,0%,5%,.212)!important;overflow:hidden!important;overflow-y:auto!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-56e7ef86","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/putMoney/addEdit.vue
// module id = 918
// module chunks = 0